<template>
  <div v-if="!isOnline" class="online-gate online-gate--offline">
    <slot name="offline">
      <OfflineEmptyState />
    </slot>
  </div>
  <slot v-else />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import OfflineEmptyState from '@/components/baseComponents/OfflineEmptyState.vue'
import { useConnectionStatus } from '@/composables/useConnectionStatus'

export default defineComponent({
  name: 'OnlineGate',

  components: {
    OfflineEmptyState,
  },

  setup() {
    const { isOnline } = useConnectionStatus()
    return {
      isOnline,
    }
  },
})
</script>

<style scoped>
.online-gate--offline {
  width: 100%;
  min-height: min(60vh, 480px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
